<template>
<div>
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>外部送信ポリシー</title>
  </head>
  <body>
    <div class="policy-container">
      <div class="policy-content">
        <h1 class="policy-title">外部送信ポリシー</h1>

        <div class="policy-introduction">
          <p>
            株式会社ゼンリンデータコム（以下「当社」）では、当社が提供するサービス（以下「本サービス」）において、利用者の利用状況を分析するため、又は個々の利用者に対してより良いサービスを提供する等の目的のため、クッキー（Cookie）及び類似技術を使用して、利用者の情報（利用者の氏名、所在地、電話番号等の個人を特定する情報は一切含まれません）を収集し、外部事業者に送信する場合があります。
          </p>
        </div>

        <div class="policy-section">
          <h2>【利用するツール、取得する情報及び利用目的】</h2>
          <p>
            本サービスにおいて、当社が利用するツール、取得する情報及び利用目的については
            以下のとおりとなります。
          </p>
        </div>

        <div class="policy-section">
          <h3>分析及び解析ツール</h3>
          <p>
            本サービスにおいては、利用者による本サービスの利用状況（アクセス状況、トラフィック、ルーティング、操作ログ等）を分析し、本サービス自体のパフォーマンス改善や、本サービスを通じて当社から利用者に提供するサービスの向上、改善のために使用するため、以下のツールを利用しています。送信される情報の内容や情報送信先における利用目的については、以下のリンク先をご確認ください。
          </p>

          <div class="tool-info">
            <h4>Google Analytics</h4>
            <p>情報送信先：Google LLCその他の関係会社</p>
            <ul>
              <li>
                <a href="https://business.safety.google/intl/ja/tba-jp/" target="_blank"
                  >電気通信事業法27条の12に基づく通知・公表のための参考情報（事業者向け）</a
                >
              </li>
              <li>
                <a
                  href="https://marketingplatform.google.com/about/analytics/terms/jp/"
                  target="_blank"
                  >Google Analytics利用規約</a
                >
              </li>
              <li>
                <a
                  href="https://policies.google.com/technologies/partner-sites?hl=ja"
                  target="_blank"
                  >Googleのサービスを利用するサイトやアプリから収集した情報のGoogleによる使用</a
                >
              </li>
            </ul>
            <h4>Amazon DynamoDB</h4>
            <p>情報送信先：Amazon Web Services,Inc.</p>
            <ul>
              <li>
                <a href="https://d1.awsstatic.com/legal/privacypolicy/AWS_Privacy_Notice_10.28.24_JA-JP.pdf" target="_blank"
                  >プライバシー通知</a
                >
              </li>
              <li>
                <a
                  href="https://d1.awsstatic.com/legal/AWS Cookies Notice/AWS_Cookie_Notice_Japanese_2022-12-30.pdf"
                  target="_blank"
                  >Cookieに関する通知</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="policy-section">
          <h3>ソーシャルネットワーキングサービス（SNS）</h3>
          <p>
            本サービスにおいては、SNSとの連携や情報の拡散等を目的として、一部のページでSNSの「ボタン」等を設置しています。この「ボタン」等が設置されたWebサイト等を閲覧した場合、「ボタン」等を押さなくとも、当該Webサイト等からSNS運営事業者に対し、当社サイトの利用に関する情報が自動で送信されることがあります。送信される情報の内容や情報送信先における利用目的については、各SNS事業者のプライバシーポリシー等をご確認ください。
          </p>

          <div class="tool-info">
            <!-- <h4>Google Analytics</h4>
            <p>情報送信先：Google LLCその他の関係会社</p> -->
            <ul>
              <li>
                <a href="https://www.ppc.go.jp/news/careful_information/sns_button_life/" target="_blank"
                  >SNSの利用者のみなさまへの留意事項（個人情報保護委員会）</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="policy-footer">
          <p>以上</p>
          <p>制定日：2025年03月25日</p>
        </div>
      </div>
    </div>
  </body>
</div>
</template>

<script>
export default {
  name: 'ExternalTransmissionPolicy'
}
</script>

<style scoped>
.policy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.policy-content {
  padding: 20px;
  line-height: 1.8;
  color: #333333;
}

.policy-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  color: #1a1a1a;
}

.policy-introduction {
  margin-bottom: 30px;
}

.policy-section {
  margin-bottom: 30px;
}

.policy-section h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.policy-section h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.policy-section h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #1a1a1a;
}

.tool-info {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  margin-top: 15px;
}

.tool-info ul {
  list-style: none;
  padding-left: 0;
  margin-top: 10px;
}

.tool-info ul li {
  margin-bottom: 8px;
}

.tool-info a {
  color: #007bff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.tool-info a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.policy-footer {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .policy-container {
    padding: 10px;
    margin: 10px;
  }

  .policy-content {
    padding: 15px;
  }

  .policy-title {
    font-size: 20px;
  }

  .policy-section h2 {
    font-size: 18px;
  }

  .policy-section h3 {
    font-size: 16px;
  }

  .policy-section h4 {
    font-size: 15px;
  }

  .tool-info {
    padding: 15px;
  }
}
</style>
